import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { CommandClickEventArgs, CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { DynamicGridBaseComponent } from 'src/app/base/shared/grid-base/dynamic-grid-base.component';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { EnumFilterService } from 'src/app/base/services/enum-filter.service';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { TripDetailDTO } from 'src/app/base/models/models.swagger.generated';
import { TripOverviewService } from './trip-overview.service';
import { tripOverviewDynamicDefinition } from './trip-overview-dynamic.definition';
import { TripDetailDialogComponent } from './trip-detail-dialog/trip-detail-dialog.component';

@Component({
  selector: 'app-trip-overview',
  templateUrl: './trip-overview.component.html',
  styleUrls: ['./trip-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, GridModule, TripDetailDialogComponent, TranslatePipe],
  providers: [TripOverviewService],
})
export class TripOverviewComponent extends DynamicGridBaseComponent<typeof tripOverviewDynamicDefinition> implements OnInit {

  public vehicleId: number | null = 1;
  public selectedTripDetail: TripDetailDTO | null = null;
  public showDetailDialog = false;

  constructor(
    private tripOverviewService: TripOverviewService,
    fb: FormBuilder,
    translateService: TranslateService,
    private spinnerService: SpinnerService,
    enumFilterService: EnumFilterService,
  ) {
    super(tripOverviewDynamicDefinition, fb, null, translateService, tripOverviewService, enumFilterService);
  }

  public ngOnInit(): void {
    this.tripOverviewService.vehicleId = this.vehicleId;
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.tripOverviewService, this.spinnerService, true),
    });
    this.editSettings = {
      allowAdding: false,
      allowEditing: false,
      allowDeleting: false,
      mode: 'Dialog',
      showDeleteConfirmDialog: false,
    };
    this.gridCommands = [{
      type: 'None',
      title: this.translateService.instant('i18n.domain.analytics.trip-overview.view-details'),
      buttonOption: {
        cssClass: 'icon-btn',
        iconCss: 'icon-view e-icons',
      },
    } as CommandModel];
  }

  public onLoadTrips(): void {
    this.tripOverviewService.vehicleId = this.vehicleId;
    this.grid?.refresh();
  }

  public commandClick(args: CommandClickEventArgs): void {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      const tripId = ((args.rowData) as any).id;
      this.tripOverviewService.getTripDetail(tripId).subscribe(detail => {
        this.selectedTripDetail = detail;
        this.showDetailDialog = true;
      });
    }
  }

  protected getEditDialogTitleParams(): object {
    return {};
  }
}
